import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { IBlueprint, IIntegration } from "../../models/integration.interface";
import { environment } from "../../../../environments/environment";
import { IMessageResponse } from "../../models";


@Injectable({
    providedIn: "root"
})
export class IntegrationService {
    private httpClient = inject(HttpClient)

    readonly endpoints = {
        getAllBlueprints: `${environment.apiUrl}/IntegrationAPI/GetAllBlueprints`,
        getAllInstallationsByOrgID: `${environment.apiUrl}/IntegrationAPI/GetInstallations`,
        addNewInstallation: `${environment.apiUrl}/IntegrationAPI/NewInstallation`,
        updateInstallation: `${environment.apiUrl}/IntegrationAPI/UpdateInstallation`,
        deleteInstallation: `${environment.apiUrl}/IntegrationAPI/DeleteInstallation`,
        fetchSites: `${environment.apiUrl}/integration/{integration_id}/sites`,
        importSites: `${environment.apiUrl}/integration/{integration_id}/sites/import`

    };

    getAllBlueprints(): Observable<IBlueprint[]> {
        let endpoint = this.endpoints.getAllBlueprints;
        return this.httpClient.post<IMessageResponse<IBlueprint[]>>(endpoint, {}).pipe(
            map(e => e.data)
        );
    }

    getAllIntegrations(organisationId: string): Observable<IIntegration[]> {
        let endpoint = this.endpoints.getAllInstallationsByOrgID;
        let _body = {
            'organisation_id': organisationId
        };
        return this.httpClient.post<IMessageResponse<IIntegration[]>>(endpoint, _body).pipe(
            map(e => e.data)
        );
    }

    // addInstallation(organisationID: string, bliueprintID: string, name: string, details: any): Observable<HttpListResponseFailure | any> {
    //     let endpoint = IntegrationsServiceConfig.endpoints.addNewInstallation;
    //     var _details = { ...details }
    //     let _body = {
    //         'organisation_id': organisationID,
    //         'details': _details,
    //         'blueprint_id': bliueprintID,
    //         'name': name
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    // updateInstallation(organisationID: string, installationID: string, updateMap: any): Observable<HttpListResponseFailure | any> {
    //     let endpoint = IntegrationsServiceConfig.endpoints.updateInstallation;
    //     let _body = {
    //         'organisation_id': organisationID,
    //         'installation_id': installationID,
    //         'update_map': updateMap
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    deleteIntegration(organisationId: string, integration: IIntegration) {
        let endpoint = this.endpoints.deleteInstallation;
        let _body = {
            'organisation_id': organisationId,
            'installation_ids': [integration.id],
        };
        return this.httpClient.post(endpoint, _body);
    }

    // loadHikInstallationSites(organisationID: string, installationID: string): Observable<HttpListResponseFailure | HttpErrorResponse | any> {
    //     let endpoint = HikIntegrationServiceConfig.endpoints.importAllSites;
    //     let _body = {
    //         'organisation_id': organisationID,
    //         'installation_id': installationID
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    // sendHikSocketConnectMessage(organisationID: string, installationID: string): Observable<HttpListResponseFailure | HttpErrorResponse | any> {
    //     let endpoint = HikIntegrationServiceConfig.endpoints.sendSocketServerMessage;
    //     let _body = {
    //         'action': 'CONNECT',
    //         'organisation_id': organisationID,
    //         'installation_id': installationID
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    // importHikInstallationSites(organisationID: string, installationID: string, regionIndexCodes: string[]): Observable<HttpListResponseFailure | HttpErrorResponse | any> {
    //     let endpoint = HikIntegrationServiceConfig.endpoints.importSiteWithCameras;
    //     let _body = {
    //         'organisation_id': organisationID,
    //         'installation_id': installationID,
    //         'regionIndexCodes': regionIndexCodes
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    // exportHikRules(installationID: string, rule_ids: string[]): Observable<HttpListResponseFailure | HttpErrorResponse | any> {
    //     let endpoint = HikIntegrationServiceConfig.endpoints.exportRules;
    //     let _body = {
    //         'installation_id': installationID,
    //         'rule_ids': rule_ids
    //     };
    //     return this.httpClient.post<HttpListResponseFailure | any>(endpoint, _body);
    // }

    // fetchSites(installation: Installation) {
    //     let endpoint = IntegrationsServiceConfig.endpoints.fetchSites
    //     endpoint = endpoint.replace("{integration_id}", installation.id)
    //     return this.httpClient.get(endpoint)
    // }

    // importSites(installation: Installation, externalIds: string[]) {
    //     let endpoint = IntegrationsServiceConfig.endpoints.importSites
    //     const _body = {
    //         "external_ids": externalIds
    //     }
    //     endpoint = endpoint.replace("{integration_id}", installation.id)
    //     return this.httpClient.post(endpoint, _body)
    // }

}
